import { getApiPublicBranchServicesQueryOptions } from '@barbershop/api/customer'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { isBranchNotFoundError } from '@/entities/branch'
import { PageSpinner } from '@/shared/ui/page-spinner'
import { BranchNotFoundState } from '@/widgets/invalid-link-state'

export const Route = createFileRoute('/_dashboard/branch/$branchId')({
    params: {
        parse: ({ branchId }) => {
            if (!/^\d+$/.test(branchId)) return false

            return { branchId: Number(branchId) }
        },
    },
    loader: async ({ context, params }) => {
        try {
            await context.queryClient.ensureQueryData({
                ...getApiPublicBranchServicesQueryOptions({ branch_id: params.branchId }),
                retry: false,
            })
        } catch (error) {
            if (isBranchNotFoundError(error)) {
                throw notFound()
            }
        }
    },
    notFoundComponent: BranchNotFoundState,
    pendingComponent: PageSpinner,
})
